module.exports = __webpack_public_path__ + "static/media/2a Cuff Ankle.49894e6e.jpg";